import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { ErrorContext } from '../context/ErrorContext';
import { UserContext } from '../context/UserContext';
import useSession from '../hooks/useSession';
import magicLinkAPI from '../services/magicLink';
import projectAPI from '../services/project';
import Toast from './layout/Toast'

const AuthGuest = () => {
    const [session, setSession] = useSession()
    const { user, setAuthUser, getCustomItem, removeCustomItem, getL10nInstance } = useContext(UserContext)
    const navigate = useNavigate();
    const [error, setError] = useState([])
    const [sended, setSended] = useState(false)
    const [l10n, setL10n] = useState(null)
    const { parseErrors } = useContext(ErrorContext)
    const [formData, setFormData] = useState({
        email_guest: ''
    });
    const {
        email_guest
    } = formData;
    const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value })
    const onSubmit = async (e) => {
        e.preventDefault()
        setError([]);
        try {
            if (checkMagicLink()) {
                const magicLink = JSON.parse(getCustomItem('bunny.MagicLink'))
                const params = {
                    magic_link: magicLink,
                    email: email_guest
                }
                const project = await projectAPI.magiclink({jwt: session, params})
                const newMagicLink = project.data.data.magic_link_project
                removeCustomItem('bunny.MagicLink')
                navigate('/invitation/' + newMagicLink)
                navigate(0)
            } else {
                const res = await magicLinkAPI.sendLink({ email: email_guest })
                // setSended(true)
                e.target.reset();
                setError([{ message: "Email to log in has been sent." }]) // TODO rename error to message or use other toast
            }
        } catch (err) {
            const parsedErr = parseErrors(err.response.data.error)
            setError(parsedErr)
        }
    }

    useEffect(() => {
      (async () => {
        const instance = await getL10nInstance();
        setL10n(instance);
      })();
    }, [session, user]);

    useEffect(() => {
        if (session && user) {
            roleManager(user)
        }
    }, [])

    const roleManager = (user) => {
        switch (user.position) {
            case 'admin':
                return navigate('/register')
            case 'am':
                return navigate('/widget#dashboard')
            default:
                return navigate('/login')
        }
    }

    const checkMagicLink = () => {
        const magicLink = getCustomItem('bunny.MagicLink')
        return magicLink ? true : false
    }

    return (
        <>
            <section className='font-helveticaNeue w-3/5 m-auto my-10 text-[#152536] bg-[#F6F6F6] h-[67vh]'>
                <h1 className='font-bold text-[40px] leading-[60px] text-center'>{l10n && l10n.getString('Sign In')}</h1>
                <p className='font-normal text-[#68717A]  text-base mt-4 text-center'>{l10n && l10n.getString('Welcome! To log in and access your project dashboard, please enter your email below and click the "send email" button.')}</p>
                <form className='mt-6 m-auto my-12 text-base bg-white w-[920px] h-[140px] rounded-2xl border border-[#CCCCCC]' onSubmit={e => onSubmit(e)}>
                    <div className='m-8'>
                        <label htmlFor="email_guest" className='block font-semibold'>{l10n && l10n.getString('Email')}*</label>
                        <div className='flex items-center justify-between'>
                            <input id="email_guest"
                                className='block w-[654px] h-12 mr-6 my-2 px-[12px] py-[12px] border border-solid border-[#B6B7C0] rounded'
                                type="email"
                                placeholder="someone@email.com"
                                onChange={e => onChange(e)}
                                name="email_guest"
                                required
                            />
                            <input
                                type="submit"
                                className={`h-12 w-[178px] rounded-[25px] font-semibold text-base text-white px-4 py-2 ${sended ? 'bg-[#6A4278] hover:bg-[#854f99]' : 'bg-[#6A4278] hover:bg-[#854f99]'}`}
                                value={l10n && `${checkMagicLink() ? l10n.getString("Go to project") : l10n.getString("Send email")}`}
                                disabled={sended}
                            />
                        </div>
                    </div>
                </form>
            </section>
            <Toast toast={error} time={3000} />
        </>
    )
}

export default AuthGuest